import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, IconButton, Tooltip } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
import CustomTable from "../../components/customTable/CustomTable";
import { partnerClient } from "../../app/slices/partnerInvoice/partnerTransactionSlice";

export default function Employee({ partnerUsername }) {
  const dispatch = useDispatch();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partnerUsername) return;

    const fetchEmployees = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          partnerClient({ partnerUsername, type: "employee" }),
        );
        // console.log(response, "employw>>>>>>>>>>>>>>..");
        if (response.meta.requestStatus === "fulfilled") {
          setEmployees(response.payload.data || []);
        }
      } catch (error) {
        console.log("error fetching employees: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [partnerUsername, dispatch]);

  // Same field shape assumed as the Client response — adjust if Employee records differ
  const sliceResponse =
    employees.length > 0 &&
    employees?.map((item) => ({
      id: item?._id || "-",
      name: item?.name || "-",
      username: item?.username || "-",
      email: item?.Email || "-",
      mobileNo: item?.PhoneNo || "-",
      partnerUsername: item?.partner_username || "-",
      partner_id: item?.partner_id || "-",
      panNumber: item?.PanNumber || "-",
      dob: item?.dob || "-",
      addressLine1: item?.address_line_1 || "-",
      addressLine2: item?.address_line_2 || "-",
      city: item?.city || "-",
      state: item?.state || "-",
      zip: item?.zip || "-",
      bankAccountNo: item?.bank_account_no || "-",
      ifscCode: item?.ifsc_code || "-",
      uniqueId: item?.uniqueId || "-",
      createdAt: item?.createdAt || "-",
      updatedAt: item?.updatedAt || "-",
    }));

  const makeCopyableColumn = (columnHelper, accessorKey, header, size = 30) =>
    columnHelper.accessor(accessorKey, {
      header,
      size,
      Cell: ({ cell }) => {
        const value = cell.row.original[accessorKey];
        const handleCopy = () => {
          navigator.clipboard.writeText(value ?? "");
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={value || "N/A"}>
            <span>
              <IconButton onClick={handleCopy} size="small">
                <ContentCopy fontSize="inherit" />
              </IconButton>
              {value}
            </span>
          </Tooltip>
        );
      },
    });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    makeCopyableColumn(columnHelper, "id", "ID"),
    columnHelper.accessor("name", { header: "Name", size: 30 }),
    columnHelper.accessor("username", { header: "UserName", size: 30 }),
    columnHelper.accessor("mobileNo", { header: "Mobile No", size: 30 }),
    columnHelper.accessor("email", { header: "Email", size: 30 }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <Box mt={2}>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={loading}
        permissionKey="PartnerEmployee"
      />
    </Box>
  );
}
